import { render, staticRenderFns } from "./CandidateAddForm.vue?vue&type=template&id=2c3341b8&scoped=true&"
import script from "./CandidateAddForm.vue?vue&type=script&lang=js&"
export * from "./CandidateAddForm.vue?vue&type=script&lang=js&"
import style0 from "./CandidateAddForm.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CandidateAddForm.vue?vue&type=style&index=1&id=2c3341b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3341b8",
  null
  
)

export default component.exports